function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useContext } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { AgroTextButton } from '../../atoms/AgroTextButton';
import { AgroDropdownMenu } from '../../atoms/AgroDropdownMenu';
import { UserNotifications } from '../UserNotifications';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { IarrowDown2, IavatarUser2 } from '../../atoms/AgroIcon/icons';
import { Box } from '../../atoms/Box';
var UserWrapper = withCssProps(function (_ref) {
  var notifications = _ref.notifications,
    loadingUser = _ref.loadingUser,
    loadingNotifications = _ref.loadingNotifications,
    buttons = _ref.buttons,
    tagManager = _ref.tagManager;
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    loginUrlRedirect = _useContext.loginUrlRedirect,
    user = _useContext.user,
    translations = _useContext.translations;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showNotifications = _useState2[0],
    setShowNotifications = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showGreenDot = _useState4[0],
    setShowGreenDot = _useState4[1];
  var loginURL = "/auth?urlRedirect=".concat(loginUrlRedirect || baseUrl);
  var toggle = function toggle() {
    var flag = !showNotifications;
    setShowNotifications(flag);
    flag ? document.addEventListener('click', handleClickOutside, true, handleClickNotifications) : document.removeEventListener('click', handleClickOutside, true);
  };
  var handleClickOutside = function handleClickOutside(event) {
    var elem = document.getElementById('user-notifications');
    var btn = document.getElementById('user-link');
    if (!(elem && elem.contains(event.target)) && !(btn && btn.contains(event.target))) {
      setShowNotifications(false);
      document.removeEventListener('click', handleClickOutside, true);
    }
  };
  var handleClick = function handleClick(text) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'Navigation',
          eventAction: 'Header',
          eventLabel: text
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var handleClickNotifications = function handleClickNotifications() {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'My account',
          eventAction: 'Open - User notifications'
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var hasNotifications = function hasNotifications(notifications) {
    notifications.ReceivedUnread && notifications.ReceivedUnread.count > 0 && setShowGreenDot(true);
    notifications.Sent && notifications.Sent.count > 0 && setShowGreenDot(true);
    notifications.showOnTop && setShowGreenDot(true);
    notifications.showOnBottom && setShowGreenDot(true);
    notifications.SELLER_PENDINGRESPONSE && notifications.SELLER_PENDINGRESPONSE.count > 0 && setShowGreenDot(true);
    notifications.SELLER_PENDINGPAYMENT && notifications.SELLER_PENDINGPAYMENT.count > 0 && setShowGreenDot(true);
    notifications.SELLER_PENDINGDELIVERY && notifications.SELLER_PENDINGDELIVERY.count > 0 && setShowGreenDot(true);
    notifications.BUYER_PENDINGACCEPTANCE && notifications.BUYER_PENDINGACCEPTANCE.count > 0 && setShowGreenDot(true);
    notifications.BUYER_PENDINGPAYMENT && notifications.BUYER_PENDINGPAYMENT.count > 0 && setShowGreenDot(true);
    notifications.BUYER_PENDINGDELIVERY && notifications.BUYER_PENDINGDELIVERY.count > 0 && setShowGreenDot(true);
  };
  useEffect(function () {
    notifications && hasNotifications(notifications);
  }, [notifications]);
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  var redirectUserNotLogged = function redirectUserNotLogged(e) {
    handleClick(e.textAnalityc);
    window.location.href = e.href;
  };
  return /*#__PURE__*/React.createElement(UserContainer, null, loadingUser ? /*#__PURE__*/React.createElement(Loading, null) : user && user.isLogged ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserLogged, null, /*#__PURE__*/React.createElement(AgroTextButton, {
    elementId: "user-link",
    parentCallback: function parentCallback() {
      return toggle();
    },
    "data-cy": "login-button"
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    height: "16px",
    width: "16px",
    fill: "gray800"
  }), user.fullName, /*#__PURE__*/React.createElement(IarrowDown2, {
    fill: "gray700"
  }), showGreenDot ? /*#__PURE__*/React.createElement(GreenDot, null) : null), showNotifications ? /*#__PURE__*/React.createElement(UserNotifications, {
    data: notifications,
    loadingNotifications: loadingNotifications,
    tagManager: tagManager
  }) : null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mr: "xs",
    display: "flex",
    "align-items": "center"
  }, /*#__PURE__*/React.createElement(IconLink, {
    id: "agro-header-login-link",
    href: loginURL,
    onMouseDown: function onMouseDown() {
      return handleClick('Login');
    }
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    height: "16px",
    width: "16px",
    fill: "gray800"
  }), /*#__PURE__*/React.createElement("span", null, showTranslation('loginLabel'))))), user && user.isLogged || (buttons === null || buttons === void 0 ? void 0 : buttons.length) === 0 ? /*#__PURE__*/React.createElement("a", {
    id: "agro-header-post-link",
    href: "/aviso/onepage/index/"
  }, /*#__PURE__*/React.createElement(PostButton, {
    id: "agro-header-post-button",
    onMouseDown: function onMouseDown() {
      return handleClick('Post');
    }
  }, /*#__PURE__*/React.createElement("span", null, showTranslation('postLabel')))) : (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && /*#__PURE__*/React.createElement(Dropdown, {
    options: buttons,
    onOptionSelected: function onOptionSelected(e) {
      return redirectUserNotLogged(e);
    },
    variant: "dark",
    defaultLabel: showTranslation('postLabel')
  }));
});
UserWrapper.propTypes = {
  user: PropTypes.object,
  notifications: PropTypes.object,
  loadingUser: PropTypes.bool,
  loadingNotifications: PropTypes.bool
};
UserWrapper.displayName = 'UserWrapper';
export { UserWrapper };
var UserContainer = styled.div.withConfig({
  displayName: "UserWrapper__UserContainer",
  componentId: "sc-1yckcj8-0"
})(["margin-left:32px;align-items:center;box-sizing:border-box;display:flex;height:41px;justify-content:flex-end;position:relative;@media (max-width:", "){display:none;}a{text-decoration:none;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint.lg;
});
var UserLogged = styled.div.withConfig({
  displayName: "UserWrapper__UserLogged",
  componentId: "sc-1yckcj8-1"
})(["position:relative;}"]);
var Dropdown = styled(AgroDropdownMenu).withConfig({
  displayName: "UserWrapper__Dropdown",
  componentId: "sc-1yckcj8-2"
})(["margin-left:24px;}"]);
var UserAvatar = styled(IavatarUser2).withConfig({
  displayName: "UserWrapper__UserAvatar",
  componentId: "sc-1yckcj8-3"
})(["margin-right:4px;}"]);
var GreenDot = styled.span.withConfig({
  displayName: "UserWrapper__GreenDot",
  componentId: "sc-1yckcj8-4"
})(["position:relative;top:-14px;right:25px;background-color:", ";width:9px;height:9px;border-radius:50px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.green500;
});
var IconLink = styled.a.withConfig({
  displayName: "UserWrapper__IconLink",
  componentId: "sc-1yckcj8-5"
})(["font-family:Montserrat,serif;align-items:center;box-sizing:border-box;color:", ";cursor:pointer;display:flex;font-size:14px;font-family:14px;line-height:20px;font-weight:500;text-decoration:none;text-transform:lowercase;padding:1px 6px;span:first-letter{text-transform:uppercase;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.gray800;
});
var gradientBackground = keyframes(["0%{opacity:0.5;}50%{opacity:1;}100%{opacity:0.5;}"]);
var Loading = styled.div.withConfig({
  displayName: "UserWrapper__Loading",
  componentId: "sc-1yckcj8-6"
})(["height:18px;width:100px;background-color:", ";animation:", " 2s ease-in-out 0s infinite reverse;margin-right:16px;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray500;
}, gradientBackground);
var PostButton = styled.button.withConfig({
  displayName: "UserWrapper__PostButton",
  componentId: "sc-1yckcj8-7"
})(["background-color:transparent;padding:0px 20px;height:40px;font-size:14px;line-height:20px;box-sizing:border-box;display:flex;justify-content:center;align-items:center;cursor:pointer;border-radius:8px;border:none;transition:all 0.3s ease;font-weight:500;font-family:", ";&:hover,&:focus{outline:none;}&:active{transition:all 450ms cubic-bezier(0.23,1,0.32,1) 0ms;}", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily;
}, function (_ref7) {
  var theme = _ref7.theme;
  return css(["border:1px solid ", ";color:", ";&:hover:not(:active),&:focus{border:1px solid ", ";color:", ";}&:active{border:1px solid ", ";color:", ";}"], theme.colors.gray500, theme.colors.gray800, theme.colors.gray700, theme.colors.gray900, theme.colors.gray700, theme.colors.black);
});